import { useState, useEffect } from "react"
import { Grid } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DataTable from "components/DataTable"
import {
  useLazyGetDashBoardQuery,
  useLazyGetTeacherTypesQuery,
} from "shared/redux/endpoints/lxo"
import moment from "moment"
import { createMockApiResponse } from "./centerDashboardMockData"
import MDButton from "components/MDButton"
import Icon from "@mui/material/Icon"
import MDInput from "components/MDInput"
import MDPagination from "components/MDPagination"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"

import {
  studentAtRiskStyle,
  studentAtRiskTitleStyle,
  tableWrapperStyle,
  chipStyle,
  offtrackStyle,
  actionButtonStyle,
} from "./style"
import makeStyles from "pages/style"
import { useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
import "./styles.scss"

export default function CenterDashboardSection({ step, setStep }) {
  const classes = makeStyles()
  // State management matching StudentAtRiskSection exactly
  const [type, setType] = useState("core")
  const auth = useSelector(selectAuth)

  const centerId = auth?.centerId

  const [triggerCenterDashboard, { isFetching: isFetchingStudentSuggestions }] =
    useLazyGetDashBoardQuery()
  const [triggerTypesTeacher, { data }] = useLazyGetTeacherTypesQuery()
  const [state, setState] = useState({
    page: 0,
    size: 10,
    sort: "id,desc",
    start: moment().format("DD-MM-YYYY"),
    end: moment().format("DD-MM-YYYY"),
  })
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
    totalPage: 0,
    totalElement: 0,
  })

  const [isLoading, setIsLoading] = useState(false)
  const [dataTable, setDataTable] = useState({
    columns: [
      { Header: "metric", accessor: "metric", width: "150px" },
      { Header: "target", accessor: "target", width: "80px" },
      { Header: "center", accessor: "center", width: "50px" },
      { Header: "region", accessor: "region", width: "50px" },
      { Header: "action", accessor: "action" },
    ],
    rows: [],
  })
  const tablePaging = {
    entriesPerPage: {
      isShow: false,
      defaultValue: 10,
      entries: [10],
    },
    pagination: { isShow: true },
    showTotalEntries: true,
  }
  const tablePagingServer = {
    entriesPerPage: {
      isShow: false,
      defaultValue: 10,
      entries: [10],
    },
    pagination: { isShow: false },
    showTotalEntries: false,
  }

  const [dataTableTeacherEfficiency, setDataTableTeacherEfficiency] = useState({
    columns: [
      { Header: "Teacher ID", accessor: "teacherId", width: "120px" },
      { Header: "Center ID", accessor: "centerId", width: "120px" },
      { Header: "Teacher name", accessor: "teacherName", width: "200px" },

      { Header: "Total classes", accessor: "totalClasses", width: "200px" },
      { Header: "Teaching hours", accessor: "teachingHours", width: "200px" },
      {
        Header: "Current week PT hours",
        accessor: "currentWeekPTHours",
        width: "300px",
      },
      { Header: "Total hours", accessor: "totalHours", width: "200px" },

      {
        Header: "Last week teaching hours",
        accessor: "lastWeekTeachingHours",
        width: "200px",
      },
      {
        Header: "Last week PT hours",
        accessor: "lastWeekPTHours",
        width: "200px",
      },
      {
        Header: "Total last week hours",
        accessor: "totalLastWeekHours",
        width: "200px",
      },

      { Header: "Public holidays", accessor: "publicHolidays", width: "200px" },
      { Header: "Working days", accessor: "workingDays", width: "200px" },

      {
        Header: "Actual required hours",
        accessor: "actualRequiredHours",
        width: "200px",
      },
      { Header: "Adjusted hours", accessor: "adjustedHours", width: "200px" },
      { Header: "Efficiency", accessor: "efficiency", width: "200px" },
      { Header: "Last efficiency", accessor: "lastEfficiency", width: "200px" },
    ],
    rows: [],
  })

  const [dataTableTeacherChange, setDataTableTeacherChange] = useState({
    columns: [
      { Header: "Center ID", accessor: "centerId", width: "120px" },
      { Header: "Center name", accessor: "centerName", width: "220px" },

      {
        Header: "Total class current",
        accessor: "totalClassCurrent",
        width: "170px",
      },
      {
        Header: "Alert class current",
        accessor: "alertClassCurrent",
        width: "170px",
      },
      {
        Header: "Alert rate current",
        accessor: "alertRateCurrent",
        width: "170px",
      },

      {
        Header: "Total class last",
        accessor: "totalClassLast",
        width: "150px",
      },
      {
        Header: "Alert classes last",
        accessor: "alertClassesLast",
        width: "160px",
      },
      { Header: "Alert rate last", accessor: "alertRateLast", width: "150px" },
    ],
  })

  const [dataTableIntensity, setDataTableIntensity] = useState({
    columns: [
      { Header: "LXO ID", accessor: "lxoId", width: "120px" },
      { Header: "LXO", accessor: "lxo", width: "200px" },
      { Header: "Center ID", accessor: "centerId", width: "120px" },
      { Header: "Center name", accessor: "centerName", width: "220px" },
      { Header: "Count 3hrs", accessor: "count3hrs", width: "120px" },
      { Header: "Count 4hrs", accessor: "count4hrs", width: "120px" },
      {
        Header: "Total class in week",
        accessor: "totalClassInWeek",
        width: "180px",
      },
      { Header: "Intensity", accessor: "intensity", width: "120px" },
    ],
    rows: [],
  })

  const [dataColumn, setDataTableColumn] = useState({
    columns: [
      { Header: "Metric", accessor: "metric", width: "200px" },
      { Header: "Month", accessor: "month", width: "120px" },
      { Header: "Region", accessor: "region", width: "150px" },
      { Header: "Value", accessor: "value", width: "150px" },
    ],
  })

  const [dataTableCancellation, setDataTableCancellation] = useState({
    columns: [
      { Header: "Week start", accessor: "weekStartDate", width: "130px" },
      { Header: "ISO year", accessor: "isoYear", width: "90px" },
      { Header: "ISO week", accessor: "isoWeek", width: "90px" },
      { Header: "Center", accessor: "center", width: "120px" },
      { Header: "Teaching hours", accessor: "teachingHours", width: "140px" },
      {
        Header: "Hours cancelled",
        accessor: "totalHoursCancelled",
        width: "140px",
      },
      {
        Header: "Hours made up",
        accessor: "totalHoursMadeUp",
        width: "140px",
      },
      { Header: "Loss hours", accessor: "lossHour", width: "120px" },
      {
        Header: "Loss hour %",
        accessor: "lossHourPct",
        width: "120px",
      },
      {
        Header: "Cancelled: sickness",
        accessor: "cancelledTeacherSickness",
        width: "160px",
      },
      {
        Header: "Cancelled: visa run",
        accessor: "cancelledTeacherVisaRun",
        width: "160px",
      },
      {
        Header: "Cancelled: on leave",
        accessor: "cancelledTeacherOnLeave",
        width: "160px",
      },
      {
        Header: "Cancelled: shortage",
        accessor: "cancelledTeacherShortage",
        width: "160px",
      },
      {
        Header: "Cancelled: force majeure",
        accessor: "cancelledForceMajeure",
        width: "180px",
      },
      {
        Header: "Cancelled: other",
        accessor: "cancelledOther",
        width: "160px",
      },
      { Header: "Created at", accessor: "createdAt", width: "180px" },
      { Header: "Updated at", accessor: "updatedAt", width: "180px" },
    ],
    rows: [],
  })

  const isBetterThanTarget = (actual, target) => {
    if (actual == null || target == null) return false
    const actualNum = parseFloat(String(actual))
    if (isNaN(actualNum)) return false
    const targetStr = String(target).trim()
    const match = targetStr.match(/^([<>][=]?|[≤≥])\s*([\d.]+)/)
    if (!match) {
      // No operator — assume higher is better
      const targetNum = parseFloat(targetStr)
      if (isNaN(targetNum)) return false
      // Target is 0: anything above 0 is bad (red)
      if (targetNum === 0) return actualNum <= 0
      return actualNum >= targetNum
    }
    const operator = match[1]
    const targetNum = parseFloat(match[2])
    if (isNaN(targetNum)) return false
    switch (operator) {
      case "<":
        return actualNum < targetNum
      case "<=":
      case "≤":
        return actualNum <= targetNum
      case ">":
        return actualNum > targetNum
      case ">=":
      case "≥":
        return actualNum >= targetNum
      default:
        return false
    }
  }

  // Mock data fetch function
  const fetchCenterDashboardData = async (params) => {
    setIsLoading(true)
    try {
      const response = await triggerCenterDashboard(params)

      if (response.status) {
        const rows = response.data.data.map((item) => ({
          metric: <MDTypography>{item.dataPoint}</MDTypography>,
          target: <MDTypography>{item.target}</MDTypography>,
          center: (
            <MDTypography
              className={
                isBetterThanTarget(item.centerActual, item.target)
                  ? classes.chipGreen
                  : classes.chipRed
              }
            >
              {item.centerActual != null ? `${item.centerActual}%` : "-"}
            </MDTypography>
          ),
          region: (
            <MDTypography
              className={
                isBetterThanTarget(item.regionAvg, item.target)
                  ? classes.chipGreen
                  : classes.chipRed
              }
            >
              {item.regionAvg != null ? `${item.regionAvg}%` : "-"}
            </MDTypography>
          ),
          action: (
            <MDButton
              sx={(theme) => ({
                ...actionButtonStyle(theme),
              })}
              onClick={() => {
                setStep(1)
                setPagination((prev) => ({ ...prev, page: 0 }))
                fetchDataTeacherTypes({
                  type: item.type,
                  centerId,
                  page: 0,
                  size: pagination.size,
                }).then(() => {
                  setType(item.type)
                })
              }}
            >
              <Icon sx={{}}>visibility</Icon>
              View details
            </MDButton>
          ),
        }))
        setDataTable((prev) => ({
          ...prev,
          rows,
        }))
      }
      return response
    } catch (error) {
      console.error("Error fetching center dashboard data:", error)
      return { status: false, message: error.message }
    } finally {
      setIsLoading(false)
    }
  }

  // Fetch data when filters change
  useEffect(() => {
    fetchCenterDashboardData({ centerId })
  }, [centerId])

  useEffect(() => {
    fetchDataTeacherTypes({ type: type, centerId })
  }, [centerId])

  const handleDataTableCancellation = (data) => {
    const rows = data?.data?.data?.map((item) => ({
      weekStartDate: <MDTypography>{item.weekStartDate ?? "-"}</MDTypography>,
      isoYear: <MDTypography>{item.isoYear ?? "-"}</MDTypography>,
      isoWeek: <MDTypography>{item.isoWeek ?? "-"}</MDTypography>,
      center: <MDTypography>{item.center ?? "-"}</MDTypography>,
      teachingHours: <MDTypography>{item.teachingHours ?? "-"}</MDTypography>,
      totalHoursCancelled: (
        <MDTypography>{item.totalHoursCancelled ?? "-"}</MDTypography>
      ),
      totalHoursMadeUp: (
        <MDTypography>{item.totalHoursMadeUp ?? "-"}</MDTypography>
      ),
      lossHour: <MDTypography>{item.lossHour ?? "-"}</MDTypography>,
      lossHourPct: <MDTypography>{item.lossHourPct ?? "-"}</MDTypography>,
      cancelledTeacherSickness: (
        <MDTypography>{item.cancelledTeacherSickness ?? "-"}</MDTypography>
      ),
      cancelledTeacherVisaRun: (
        <MDTypography>{item.cancelledTeacherVisaRun ?? "-"}</MDTypography>
      ),
      cancelledTeacherOnLeave: (
        <MDTypography>{item.cancelledTeacherOnLeave ?? "-"}</MDTypography>
      ),
      cancelledTeacherShortage: (
        <MDTypography>{item.cancelledTeacherShortage ?? "-"}</MDTypography>
      ),
      cancelledForceMajeure: (
        <MDTypography>{item.cancelledForceMajeure ?? "-"}</MDTypography>
      ),
      cancelledOther: <MDTypography>{item.cancelledOther ?? "-"}</MDTypography>,
      createdAt: (
        <MDTypography>
          {moment(item.createdAt).format("DD/MM/YYYY HH:mm") ?? "-"}
        </MDTypography>
      ),
      updatedAt: (
        <MDTypography>
          {moment(item.updatedAt).format("DD/MM/YYYY HH:mm") ?? "-"}
        </MDTypography>
      ),
    }))
    setDataTableCancellation((prev) => ({
      ...prev,
      rows,
    }))
  }

  const fetchDataTeacherTypes = async (params) => {
    const type = params.type
    try {
      setIsLoading(true)
      await triggerTypesTeacher({
        type: type,
        centerId,
        page: params.page ?? pagination.page,
        size: params.size ?? pagination.size,
      }).then((response) => {
        const data = response?.data
        type === "teacherEfficiency" && handleDataTableTeacherEfficiency(data)
        type === "teacherChange" && handlerDataTableColumn(data)
        type === "cancellation" && handleDataTableCancellation(data)
        type === "intensity" && handlerDataTableColumn(data)
        type === "acs" && handlerDataTableColumn(data)
        type === "glxmEfficiency" && handlerDataTableColumn(data)
        type === "taFeedback" && handlerDataTableColumn(data)
        type === "reportCompletion" && handlerDataTableColumn(data)
        type === "photoGallery" && handlerDataTableColumn(data)
        type === "wbCompletion" && handlerDataTableColumn(data)
        type === "lowTestScore" && handlerDataTableColumn(data)
        type === "renewalRate" && handlerDataTableColumn(data)
        type === "taObservation" && handlerDataTableColumn(data)
        type === "academicFeedback" && handlerDataTableColumn(data)
        type === "lowTestScore" && handlerDataTableColumn(data)

        const meta = response?.data?.data
        setPagination((prev) => ({
          ...prev,
          page: meta?.currentPage ?? params.page ?? prev.page,
          size: meta?.pageSize ?? params.size ?? prev.size,
          totalPage: meta?.totalPage ?? 0,
          totalElement: meta?.totalElement ?? 0,
        }))
      })
      setIsLoading(false)
    } catch (error) {
      console.error("Error fetching teacher types data:", error)
    }
  }

  const handleDataTableTeacherChange = (data) => {
    const rows = data?.data?.data?.map((item) => ({
      centerId: <MDTypography>{item.centerId}</MDTypography>,
      centerName: <MDTypography>{item.centerName ?? "-"}</MDTypography>,
      totalClassCurrent: (
        <MDTypography>{item.totalClassesCurrent ?? "-"}</MDTypography>
      ),
      alertClassCurrent: (
        <MDTypography>{item.alertClassCurrent ?? "-"}</MDTypography>
      ),
      alertRateCurrent: (
        <MDTypography>{item.alertRateCurrent ?? "-"}</MDTypography>
      ),
      totalClassLast: <MDTypography>{item.value ?? "-"}</MDTypography>,
      alertClassesLast: (
        <MDTypography>{item.alertClassLast ?? "-"}</MDTypography>
      ),
      alertRateLast: <MDTypography>{item.alertRateLast ?? "-"}</MDTypography>,
    }))

    setDataTableTeacherChange((prev) => ({
      ...prev,
      rows,
    }))
  }

  const handleDataTableIntensity = (data) => {
    const rows = data?.data?.data?.map((item) => ({
      lxoId: <MDTypography>{item.lxoId ?? "-"}</MDTypography>,
      lxo: <MDTypography>{item.lxo ?? "-"}</MDTypography>,
      centerId: <MDTypography>{item.centerId ?? "-"}</MDTypography>,
      centerName: <MDTypography>{item.centerName ?? "-"}</MDTypography>,
      count3hrs: <MDTypography>{item.count3hrs ?? "-"}</MDTypography>,
      count4hrs: <MDTypography>{item.count4hrs ?? "-"}</MDTypography>,
      totalClassInWeek: (
        <MDTypography>{item.totalClassInWeek ?? "-"}</MDTypography>
      ),
      intensity: <MDTypography>{item.intensity ?? "-"}</MDTypography>,
    }))

    setDataTableIntensity((prev) => ({
      ...prev,
      rows,
    }))
  }

  const handlerDataTableColumn = (data) => {
    const rows = data?.data?.data?.map((item) => ({
      ...item,
      metric: <MDTypography>{item?.id?.metricName}</MDTypography>,
      month: <MDTypography>{item?.id?.month}</MDTypography>,
      region: <MDTypography>{item?.id?.region}</MDTypography>,
    }))
    setDataTableColumn((prev) => ({
      ...prev,
      rows,
    }))
  }

  const handleDataTableTeacherEfficiency = (data) => {
    const rows = data?.data?.data?.map((item) => ({
      teacherId: <MDTypography>{item.teacherId ?? "-"}</MDTypography>,
      centerId: <MDTypography>{item.centerId}</MDTypography>,
      teacherName: <MDTypography>{item.teacherName ?? "-"} </MDTypography>,

      totalClasses: <MDTypography>{item.totalClasses ?? "-"}</MDTypography>,
      teachingHours: <MDTypography>{item.teachingHours ?? "-"}</MDTypography>,
      currentWeekPTHours: (
        <MDTypography>{item.currentWeekPtHours ?? "-"}</MDTypography>
      ),
      totalHours: <MDTypography>{item.totalHours ?? "-"}</MDTypography>,

      lastWeekTeachingHours: (
        <MDTypography>{item.lastWeekTeachingHours ?? "-"} </MDTypography>
      ),
      lastWeekPTHours: (
        <MDTypography>{item.lastWeekPTHours ?? "-"}</MDTypography>
      ),
      totalLastWeekHours: (
        <MDTypography>{item.totalLastWeekHours ?? "-"}</MDTypography>
      ),

      publicHolidays: <MDTypography>{item.publicHolidays ?? "-"}</MDTypography>,
      workingDays: <MDTypography>{item.workingDays ?? "-"}</MDTypography>,

      actualRequiredHours: (
        <MDTypography>{item.actualRequiredHours ?? "-"}</MDTypography>
      ),
      adjustedHours: <MDTypography>{item.adjustedHours ?? "-"}</MDTypography>,

      efficiency: <MDTypography>{item.efficiency ?? "-"}</MDTypography>,
      lastEfficiency: <MDTypography>{item.lastEfficiency ?? "-"}</MDTypography>,
    }))

    setDataTableTeacherEfficiency((prev) => ({
      ...prev,
      rows,
    }))
  }

  const pagedTypes = [
    "teacherEfficiency",
    "teacherChange",
    "cancellation",
    "intensity",
    "renewalRate",
    "lowTestScore",
    "wbCompletion",
    "photoGallery",
    "reportCompletion",
    "taFeedback",
    "glxmEfficiency",
    "acs",
    "taObservation",
    "academicFeedback",
    "lowTestScore",
  ]
  const isPagedType = pagedTypes.includes(type)
  const showingStart =
    pagination.totalElement === 0 ? 0 : pagination.page * pagination.size + 1
  const showingEnd = Math.min(
    (pagination.page + 1) * pagination.size,
    pagination.totalElement
  )
  const pageOptions = Array.from(
    { length: pagination.totalPage || 0 },
    (_, i) => i
  )
  const getPageItems = (current, total) => {
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i)
    }
    const items = new Set([0, total - 1, current - 1, current, current + 1])
    const normalized = Array.from(items)
      .filter((i) => i >= 0 && i < total)
      .sort((a, b) => a - b)

    const result = []
    for (let i = 0; i < normalized.length; i += 1) {
      const val = normalized[i]
      const prev = normalized[i - 1]
      if (i > 0 && val - prev > 1) {
        result.push("ellipsis")
      }
      result.push(val)
    }
    return result
  }
  const handleGotoPage = (pageIndex) => {
    const safePage =
      pageIndex < 0
        ? 0
        : pageIndex >= pagination.totalPage
        ? pagination.totalPage - 1
        : pageIndex
    setPagination((prev) => ({ ...prev, page: safePage }))
    fetchDataTeacherTypes({
      type,
      centerId,
      page: safePage,
      size: pagination.size,
    })
  }

  return (
    <Grid
      item
      xs={12}
      lg={step > 0 ? 12 : 8}
      xxl={step > 0 ? 12 : 7.5}
      className={`student-at-risk-section `}
    >
      <MDBox
        height="100%"
        sx={(theme) => studentAtRiskStyle(theme)}
        className="center-dashboard-section "
      >
        <InfoIcon
          teacherInfoIconBlock={teacherInfoIconBlock.STUDENT_AT_RISK}
          type={TooltipType.TYPE_1}
          color={TooltipIconColor.BLUE}
          className={classes.containerInfoIconWith1}
        >
          <MDTypography
            px={3}
            py={2}
            lineHeight={1}
            variant="h3"
            sx={(theme) => studentAtRiskTitleStyle(theme)}
          >
            CENTER DASHBOARD
          </MDTypography>
        </InfoIcon>

        {isLoading ? (
          <></>
        ) : (
          <MDBox px={3} pb={3} sx={(theme) => tableWrapperStyle(theme)}>
            {type === "core" && (
              <DataTable
                table={dataTable}
                isLoading={isLoading}
                canSearch={false}
                noEndBorder
                entriesPerPage={tablePaging.entriesPerPage}
                pagination={tablePaging.pagination}
                showTotalEntries={tablePaging.showTotalEntries}
              />
            )}
            {type === "cancellation" && (
              <DataTable
                table={dataTableCancellation}
                isLoading={isLoading}
                canSearch={false}
                noEndBorder
                entriesPerPage={tablePagingServer.entriesPerPage}
                pagination={tablePagingServer.pagination}
                showTotalEntries={tablePagingServer.showTotalEntries}
              />
            )}
            {type === "teacherEfficiency" && (
              <DataTable
                table={dataTableTeacherEfficiency}
                isLoading={isLoading}
                canSearch={false}
                noEndBorder
                entriesPerPage={tablePagingServer.entriesPerPage}
                pagination={tablePagingServer.pagination}
                showTotalEntries={tablePagingServer.showTotalEntries}
              />
            )}

            {[
              "renewalRate",
              "lowTestScore",
              "wbCompletion",
              "photoGallery",
              "reportCompletion",
              "taFeedback",
              "glxmEfficiency",
              "acs",
              "intensity",
              "teacherChange",
              "taObservation",
              "academicFeedback",
              "lowTestScore",
            ].includes(type) && (
              <DataTable
                table={dataColumn}
                isLoading={isLoading}
                canSearch={false}
                noEndBorder
                entriesPerPage={tablePagingServer.entriesPerPage}
                pagination={tablePagingServer.pagination}
                showTotalEntries={tablePagingServer.showTotalEntries}
              />
            )}
            {isPagedType && (
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "flex-start", sm: "center" }}
                p={3}
              >
                <MDBox mb={{ xs: 3, sm: 0 }}>
                  <MDTypography
                    variant="button"
                    color="secondary"
                    fontWeight="regular"
                  >
                    Showing {showingStart} to {showingEnd} of{" "}
                    {pagination.totalElement} entries
                  </MDTypography>
                </MDBox>
                {pagination.totalPage > 1 && (
                  <MDPagination variant="gradient" color="info">
                    {pagination.page > 0 && (
                      <MDPagination
                        item
                        onClick={() => handleGotoPage(pagination.page - 1)}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                      </MDPagination>
                    )}
                    {getPageItems(pagination.page, pagination.totalPage).map(
                      (item, idx) =>
                        item === "ellipsis" ? (
                          <MDPagination item key={`e-${idx}`} disabled>
                            <Icon sx={{ fontWeight: "bold" }}>more_horiz</Icon>
                          </MDPagination>
                        ) : (
                          <MDPagination
                            item
                            key={item}
                            onClick={() => handleGotoPage(item)}
                            active={pagination.page === item}
                          >
                            {item + 1}
                          </MDPagination>
                        )
                    )}
                    {pagination.page < pagination.totalPage - 1 && (
                      <MDPagination
                        item
                        onClick={() => handleGotoPage(pagination.page + 1)}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                      </MDPagination>
                    )}
                  </MDPagination>
                )}
              </MDBox>
            )}
            {[
              "teacherEfficiency",
              "teacherChange",
              "cancellation",
              "intensity",
              "renewalRate",
              "lowTestScore",
              "wbCompletion",
              "photoGallery",
              "reportCompletion",
              "taFeedback",
              "glxmEfficiency",
              "acs",
              "taObservation",
              "academicFeedback",
              "lowTestScore",
            ].includes(type) && (
              <MDButton
                sx={(theme) => ({
                  ...actionButtonStyle(theme),
                  marginTop: "16px",
                  marginLeft: "auto",
                })}
                onClick={() => {
                  setStep(0)
                  setType("core")
                }}
              >
                <Icon sx={{}}>arrow_back</Icon>
                Back
              </MDButton>
            )}
          </MDBox>
        )}
      </MDBox>
    </Grid>
  )
}
